export default __webpack_public_path__ + "static/media/ss_1c2b01ef93a31b2505a36c075740a5f11a879b0b.1920x1080.991a2be1.jpg";